import { render, staticRenderFns } from "./UpdateUnitName.vue?vue&type=template&id=5d70b9e6&scoped=true";
import script from "./UpdateUnitName.vue?vue&type=script&lang=js";
export * from "./UpdateUnitName.vue?vue&type=script&lang=js";
import style0 from "./UpdateUnitName.vue?vue&type=style&index=0&id=5d70b9e6&prod&lang=less&scoped=true";

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js";
var component = normalizer(script, render, staticRenderFns, false, null, "5d70b9e6", null);
export default component.exports;